import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import './App.scss';
import AppRoutes from './AppRoutes';
import Navbar from './shared/Navbar';
import Sidebar from './shared/Sidebar';
import Footer from './shared/Footer';
import axios from "axios";

const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
const nodeMode = process.env.NODE_ENV;

// Base URL setup with trailing slash fix
let baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;
if (baseUrl && !baseUrl.endsWith('/')) {
    baseUrl += '/';
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFullPageLayout: false,
      usertype: null,
      userAname: "",
      loading: true
    };
  }

  componentDidMount() {
    this.onRouteChanged();
    this.checkUserAuth();
  }

  checkUserAuth = () => {
    const token = localStorage.getItem("token");

    // 1. Agar token nahi hai, toh request mat bhejo
    if (!token) {
        this.setState({ loading: false });
        // Agar page login/register nahi hai, toh redirect karein
        if (!this.state.isFullPageLayout) {
            // window.location.href = "/adminlogin";
        }
        return;
    }

    // 2. Token ke saath request bhejein
    axios.get(`${baseUrl}me`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(res => {
      const data = res.data;
      
      // Admin/Agent permissions set karein
      const commonState = {
        userAname: data.Name,
        usertype: data.user_type,
        loading: false
      };

      if (data.user_type === "Admin") {
        this.setState({
          ...commonState,
          dashboard: true, earnings: true, allAdmins: true, newAdmin: true,
          allUsers: true, sitesettings: true, newUser: true, pendingKyc: true,
          completedKyc: true, rejectKyc: true, allChallenges: true,
          completedChallenges: true, conflictChallenges: true,
          cancelledChallenges: true, runningChallenges: true,
          newChallenge: true, penaltyBonus: true, depositHistory: true,
          bonusHistory: true, withdrawlHistory: true,
          allWithdrawlRequests: true, allDepositRequests: true,
          pages: true, bonusReport: true, penaltyReport: true,
          withdrawalReport: true, depositReport: true, dropChallenges: true,
        });
      } else if (data.user_type === "Agent") {
        this.setState({
          ...commonState,
          dashboard: data.Permissions[0]?.Status,
          earnings: data.Permissions[1]?.Status,
          allAdmins: data.Permissions[2]?.Status,
          newAdmin: data.Permissions[3]?.Status,
          allUsers: data.Permissions[4]?.Status,
          newUser: data.Permissions[5]?.Status,
          pendingKyc: data.Permissions[6]?.Status,
          completedKyc: data.Permissions[7]?.Status,
          rejectKyc: data.Permissions[8]?.Status,
          allChallenges: data.Permissions[9]?.Status,
          completedChallenges: data.Permissions[10]?.Status,
          conflictChallenges: data.Permissions[11]?.Status,
          cancelledChallenges: data.Permissions[12]?.Status,
          runningChallenges: data.Permissions[13]?.Status,
          newChallenge: data.Permissions[14]?.Status,
          penaltyBonus: data.Permissions[15]?.Status,
          depositHistory: data.Permissions[16]?.Status,
          withdrawlHistory: data.Permissions[17]?.Status,
          allWithdrawlRequests: data.Permissions[18]?.Status,
          allDepositRequests: data.Permissions[19]?.Status,
          pages: data.Permissions[20]?.Status,
          bonusHistory: data.Permissions[21]?.Status,
          bonusReport: data.Permissions[22]?.Status,
          withdrawalReport: data.Permissions[23]?.Status,
          depositReport: data.Permissions[24]?.Status,
          penaltyReport: data.Permissions[25]?.Status,
          dropChallenges: data.Permissions[26]?.Status,
        });
      }
    }).catch(err => {
      console.log("Auth Error:", err);
      this.setState({ loading: false });
      
      // 3. FIX: Agar 401 Unauthorized aaye toh logout karein
      if (err.response && err.response.status === 401) {
        localStorage.removeItem("token");
        // Prevent infinite reload on login page
        if (!this.state.isFullPageLayout) {
            window.location.href = "/adminlogin";
        }
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    window.scrollTo(0, 0);
    const fullPageLayoutRoutes = [
      '/user-pages/login-1', '/user-pages/login-2', '/user-pages/register-1', 
      '/user-pages/register-2', '/user-pages/lockscreen', '/error-pages/error-404', 
      '/error-pages/error-500', '/general-pages/landing-page', '/landing', "/login", 
      "/register", "/adminlogin", "/home", "/profile", "/help", "/Deposit", "/", 
      "/Homepage/pOPULAR", "/KYC/update-pan", "/KYC/update-aadhar", "/Games", 
      "/Referral-history", "/wallet", "/support", "/Withdrawopt", 
      "/Addcase", "/Addfunds", "/Notification", "/refer", "/transaction", 
      "/transaction-history", "/web" ,"/return","/redeem/refer"
    ];

    let isFullPage = false;
    for (let i = 0; i < fullPageLayoutRoutes.length; i++) {
      if (this.props.location.pathname === fullPageLayoutRoutes[i]) {
        isFullPage = true;
        break;
      }
    }

    if (this.props.location.pathname.split("/")[1] === 'landing' || 
        this.props.location.pathname.split("/")[1] === 'viewgame1') {
      isFullPage = true;
    }

    this.setState({ isFullPageLayout: isFullPage });
    
    const wrapper = document.querySelector('.page-body-wrapper');
    if (wrapper) {
      if (isFullPage) wrapper.classList.add('full-page-wrapper');
      else wrapper.classList.remove('full-page-wrapper');
    }
  }

  render() {
    let navbarComponent = !this.state.isFullPageLayout ? <Navbar usertype={this.state.usertype} userAname={this.state.userAname} /> : '';
    let sidebarComponent = !this.state.isFullPageLayout ? <Sidebar {...this.state} /> : '';
    let footerComponent = !this.state.isFullPageLayout ? <Footer /> : '';

    return (
      <div className="container-scroller">
        {sidebarComponent}
        <div className="container-fluid page-body-wrapper">
          {navbarComponent}
          <div className="main-panel">
            <div className="content-wrapper" style={{backgroundColor:"#66D671"}}>
              <AppRoutes />
            </div>
            {footerComponent}
          </div>
        </div>
      </div>
    );
  }
}

export default (withRouter(App));